import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import { getTopSubscribers } from '../../../selectors/reports';
import { Props } from './TopSubscribersSection';

type StateProps = Pick<Props, 'data'>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  data: getTopSubscribers(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
